import { Timezones } from '@hero/schema';

export const time = {
  /** the default timezone for the app */
  defaultTimezone: 'Asia/Riyadh' as Timezones,
} as const;
